// extracted by mini-css-extract-plugin
export default {"thankyou-screen":"ThankYouScreen_thankyou-screen__+Pgjt"};